module.exports = __webpack_public_path__ + "static/media/intro.fa2b947c.mp3";